import React from "react";
import { Footer } from "../Footer";

interface LayoutMainProps {
    children: React.ReactNode;
}

export default function LayoutMain({ children }: LayoutMainProps) {
    return (
        <>
            {children} <Footer />
        </>
    );
}
